module.exports = __webpack_public_path__ + "img/icon_repairs.f51539d5.png";